import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "./Nav";
import { useLang } from "@/i18n";

const accents = ["text-neon-teal", "text-neon-pink", "text-neon-green"];

export default function Manifesto() {
  const { t } = useLang();
  const chapters = t("about.chapters");
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative mx-auto max-w-[1600px] px-6 py-24 md:px-12 md:py-36"
    >
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-16 text-xs font-bold uppercase tracking-[0.25em] text-neon-teal"
        data-testid="about-eyebrow"
      >
        {t("about.eyebrow")}
      </motion.p>

      <div className="flex flex-col gap-20 md:gap-28">
        {chapters.map((c, i) => {
          const num = String(i + 1).padStart(2, "0");
          const accent = accents[i % accents.length];
          return (
          <motion.div
            key={num}
            data-testid={`about-chapter-${num}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, ease: [0.33, 1, 0.68, 1] }}
            className={`relative flex flex-col gap-6 md:flex-row md:items-start md:gap-16 ${
              i % 2 === 1 ? "md:pl-[15%]" : ""
            }`}
          >
            <span
              className="text-outline select-none font-display text-7xl font-semibold leading-none md:text-[9rem]"
              aria-hidden="true"
            >
              {num}
            </span>
            <div className="md:-ml-6 md:pt-6">
              <h2
                className={`font-display text-4xl font-medium tracking-tight md:text-6xl ${accent}`}
              >
                {c.title}
              </h2>
              <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#6B655F] md:text-lg">
                {c.body}
              </p>
            </div>
          </motion.div>
          );
        })}

        <motion.div
          data-testid="about-chapter-04"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.33, 1, 0.68, 1] }}
          className="relative flex flex-col gap-6 border border-[#E6E2DC] bg-white p-8 backdrop-blur-2xl md:flex-row md:items-center md:gap-16 md:p-12"
        >
          <span
            className="text-outline-teal select-none font-display text-7xl font-semibold leading-none md:text-[9rem]"
            aria-hidden="true"
          >
            04
          </span>
          <div className="md:-ml-6">
            <h2 className="font-display text-4xl font-medium tracking-tight text-[#141210] md:text-6xl">
              {t("about.hiringA")} <span className="text-neon-teal">{t("about.hiringB")}</span>
            </h2>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#6B655F] md:text-lg">
              {t("about.hiringBody")}
            </p>
            <button
              data-testid="hiring-cta-button"
              onClick={() => scrollToId("contact")}
              className="mt-8 inline-flex items-center gap-3 bg-[#141210] px-8 py-4 text-xs font-bold uppercase tracking-[0.15em] text-[#FAF8F5] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-neon-teal"
            >
              {t("about.hiringCta")} <ArrowRight size={16} />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
